module.exports = __webpack_public_path__ + "img/BirlaCarbon.d4d66199.png";